<template>
  <div>
    <v-alert
      v-if="currPosBlocked"
      dense
      border="left"
      type="warning"
      dismissible
    >
      Chức năng tìm <strong>vị trí hiện tại</strong> đang bị khóa, vui lòng kiểm tra lại!
    </v-alert>
    <v-progress-circular
      v-if="mapLoading"
      :size="30"
      color="primary"
      indeterminate
    ></v-progress-circular>
    <GmapMap
      v-show="markers"
      :center="center"
      :zoom="zoom"
      map-type-id="terrain"
      class="mapview"
      ref="mapRef"
      :options="mapOptions"
    >
      <DirectionsRenderer 
        travelMode="DRIVING" 
        :origin="origin" 
        :destination="destination"
        strokeColor="#1967d2"
        strokeWeight="7"
      />
      <DirectionsRenderer 
        travelMode="DRIVING" 
        :origin="origin" 
        :destination="destination"
        strokeColor="#00b0ff"
        strokeWeight="5"
      />
      <GmapMarker
        :key="`A${index}`"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        :icon="{ url: require('@/assets/marker.png'), scaledSize: {width: 20, height: 20}}"
        @click="toggleInfoWindow(m, index)"
      />
      <GmapInfoWindow
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
      >
        <div v-html="infoContent" @click="goBusinessDetail(businessId)"/>
      </GmapInfoWindow>
    </GmapMap>
  </div>
</template>
<script>
  import DirectionsRenderer from "@/components/public/business/DirectionsRenderer";
  export default {
    props: {
      markersOri: {
        type: Array
      },
      addressSelected: {
        type: Number
      },
      items: {
        type: Array
      },
    },
    components: {
      DirectionsRenderer,
    },
    data: () => ({
      center : { 
        lat : 10.420288, 
        lng : 106.296844
      },
      zoom: 8,
      mapOptions: null,
      infoContent: '',
      businessId: null,
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -20
        }
      },
      origin: {},
      destination: {},
      markers: [],
      markersTmp: [],
      currMarkerTmp: null,
      destMarkerTmp: null,
      currPosBlocked: false,
      mapLoading: false
    }),
    watch: {
      markersOri(){
        this.initMap();
      },
      addressSelected() {
        this.routeDrawing();
      }
    },
    mounted() {
      this.mapLoading = true;
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.mapLoading = false;
      })
    },
    methods: {
      initMap(){
        this.markers = this.markersOri;
        this.zoom=11;
      },
      routeDrawing(){
        const app = this;

        if(app.currMarkerTmp) {
          app.currMarkerTmp.setMap(null);
        }

        if(app.destMarkerTmp) {
          app.destMarkerTmp.setMap(null);
        }

        if(app.addressSelected >= 0 && app.addressSelected != null) {
          if(app.markersTmp.length == 0){
            app.markersTmp = [...app.markers];
          }
          app.markers = [];
          let itemSelected = app.items[app.addressSelected];
          let address = "";
          let main_address = `${itemSelected.dmXa.ten}, ${itemSelected.dmHuyen.ten}, ${itemSelected.dmTinh.ten}`;
          if(itemSelected.duong){
            address = `${itemSelected.duong}, ${main_address}`;
          } else {
            address = main_address;
          }

          if(itemSelected.toaDo){
            let latitude = parseFloat(itemSelected.toaDo.trim().split(',')[0]);
            let longitude = parseFloat(itemSelected.toaDo.trim().split(',')[1]);
            app.destination = new google.maps.LatLng(latitude, longitude);
            // đặt lại marker cho vị trí đích
            app.destMarkerTmp = new google.maps.Marker({
              position: {
                lat: latitude,
                lng: longitude
              },
              animation: google.maps.Animation.DROP,
              icon: { 
                url: require('@/assets/marker.png'),
                scaledSize: {width: 20, height: 20}
              },
              map: app.$refs.mapRef.$mapObject
            });

            app.toggleInfoWindow({
              id: itemSelected.id,
              name: itemSelected.tenCoSo,
              location: address,
              position: {
                lat: latitude,
                lng: longitude
              }
            }, itemSelected.id);
          }

          navigator.geolocation.getCurrentPosition(function(position) {
            app.origin = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            // reset marker to current position
            app.currMarkerTmp = new google.maps.Marker({
              position: {
                lat: position.coords.latitude, 
                lng: position.coords.longitude
              },
              animation: google.maps.Animation.DROP,
              icon: { 
                url: require('@/assets/current_pos.png'), 
                scaledSize: {width: 45, height: 45}
              },
              map: app.$refs.mapRef.$mapObject
            });
            const infowindow_curr = new google.maps.InfoWindow({
              content: app.getInfoWindowContentCurr('Vị trí hiện tại'),
            });
            infowindow_curr.open({
              anchor: app.currMarkerTmp,
              map: app.$refs.mapRef.$mapObject,
              shouldFocus: false,
            });
          },
          function(error) {
            if (error.code == error.PERMISSION_DENIED){
              console.log("you denied me :-(");
              app.currPosBlocked=true;
              app.origin = new google.maps.LatLng(app.defaultCurrent.lat, app.defaultCurrent.lng);
              app.currMarkerTmp = new google.maps.Marker({
                position: {
                  lat: app.defaultCurrent.lat,
                  lng:  app.defaultCurrent.lng
                },
                icon: { 
                  url: require('@/assets/current_pos.png'), 
                  scaledSize: {width: 18, height: 18}
                },
                map: app.$refs.mapRef.$mapObject
              });

              const infowindow_curr = new google.maps.InfoWindow({
                content: app.getInfoWindowContentCurr('Vị trí hiện tại'),
              });
              infowindow_curr.open({
                anchor: app.currMarkerTmp,
                map: app.$refs.mapRef.$mapObject,
                shouldFocus: false,
              });
            }
          });
        } else {
          let map = app.$refs.mapRef.$mapObject;
          map.setZoom(11);
          app.markers = app.markersTmp;
          app.center = { lat : 10.420288, lng : 106.296844};
          map.setCenter({ lat : 10.420288, lng : 106.296844});
          app.origin = null;
          app.destination = null;
          app.infoWinOpen = false;
        }
      },
      toggleInfoWindow: function (marker, idx) {
        this.infoWindowPos = marker.position;
        this.businessId = marker.id;
        this.infoContent = this.getInfoWindowContent(marker);

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
      getInfoWindowContent: function (marker) {
        return (
          `<a class="primary--text">
            <div>
              <span class="font-weight-bold">Tên cơ sở: </span>
              ${marker.name}
            </div>
            <div>
              <span class="font-weight-bold">Địa chỉ: </span>
              ${marker.location}
            </div>
          </a>`
        );
      },
      getInfoWindowContentCurr: function (location) {
        return (`<div>${location}</div>`);
      },
      goBusinessDetail(id){
        this.$router.push({name:'BusinessView',params:{ id:id }});
      }
    }
  }
</script>
<style>
.mapview{
  width: 100%;
  height: calc(70vh);
  border: 1px solid transparent;
  overflow: hidden;
}
</style>